import type { TFunction } from "i18next";
import { INTERNAL_REFERENCE, isInternalReference } from "@hisense/shared";

/**
 * Số đơn bán hàng / PI / phiếu giao ở các khâu sau chuỗi bán hàng (MRP, sản xuất, giữ hàng, nhập kho, đơn mua, xuất bán).
 * Máy chủ thay số của khách người xem không được thấy bằng `INTERNAL_REFERENCE` (YC-01, 07/10/2026); ở đây chỉ dịch nhãn đó.
 */
export function referenceLabel(t: TFunction, label: string | null | undefined): string {
  if (label == null) return "";
  return isInternalReference(label) ? t("common.internalReference") : label;
}

/** Chữ đã ghép sẵn số đơn (cảnh báo MRP, nhãn giữ hàng): dịch mọi chỗ máy chủ đã thay bằng nhãn nội bộ. */
export function referenceText(t: TFunction, text: string | null | undefined): string {
  if (!text) return "";
  return text.split(INTERNAL_REFERENCE).join(t("common.internalReference"));
}

/** Có trỏ được sang trang chứng từ không — nhãn nội bộ thì không (trang đó sẽ báo không tìm thấy). */
export const canOpenReference = (label: string | null | undefined) => !!label && !isInternalReference(label);
